'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = checkPlatform;
function checkPlatform(forceMobile) {

    var platform;

    // for mobile testing
    if (forceMobile) {
        platform = 'mobile';
    } else {

        var w = window.innerWidth;
        var ua = navigator.userAgent;

        // c.f. http://stackoverflow.com/questions/16443380/common-css-media-queries-break-points
        if (w < 767 || ua.match(/iphone/gi) !== null) {
            // Mobile phone
            platform = 'mobile';
        } else {
            if (ua.match(/ipad|android|tablet/gi) !== null) {
                // Tablet
                platform = 'mobile';
            } else {
                // Desktop
                platform = 'desktop';
            }
        }
    }

    return platform;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/check-platform.js
 ** module id = 761
 ** module chunks = 0 1
 **/